// utils/runtimeEnv.ts
export type OsT = 'ios' | 'android' | 'other';

export type RuntimeEnvT = {
  os: OsT;
  userAgent: string;

  // 실행 형태
  isStandalone: boolean; // PWA 홈화면 실행
  isNativeAndroidApp: boolean; // AnotherClassAttNative/1.0 (WebView 앱)

  // 기능 지원
  hasAndroidTtsBridge: boolean; // window.AndroidTTS.speak
  hasWebTts: boolean; // speechSynthesis 지원
};

export const isBrowser = () => typeof window !== 'undefined';

export const getUserAgent = (): string =>
  isBrowser() ? window.navigator.userAgent ?? '' : '';

export const detectOs = (ua = getUserAgent()): OsT => {
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'other';
};

export const detectStandalone = (): boolean => {
  if (!isBrowser()) return false;

  // Android PWA
  const androidStandalone =
    window.matchMedia?.('(display-mode: standalone)')?.matches ?? false;

  // iOS PWA
  const iosStandalone = (window.navigator as any).standalone === true;

  return androidStandalone || iosStandalone;
};

export const detectNativeAndroidApp = (ua = getUserAgent()): boolean => {
  return /Android/i.test(ua) && /AnotherClassAttNative/i.test(ua);
};

export const hasAndroidTtsBridge = (): boolean => {
  if (!isBrowser()) return false;
  const w = window as any;
  return typeof w.AndroidTTS?.speak === 'function';
};

export const hasWebTts = (): boolean => {
  if (!isBrowser()) return false;
  return (
    'speechSynthesis' in window &&
    typeof (window as any).SpeechSynthesisUtterance === 'function'
  );
};

export const getRuntimeEnv = (): RuntimeEnvT => {
  const userAgent = getUserAgent();
  const os = detectOs(userAgent);

  return {
    os,
    userAgent,
    isStandalone: detectStandalone(),
    isNativeAndroidApp: detectNativeAndroidApp(userAgent),
    hasAndroidTtsBridge: hasAndroidTtsBridge(),
    hasWebTts: hasWebTts(),
  };
};
